import { BaseService } from '../../infra/base.service'
import type { Document } from './document'
import type { DocumentsRepository } from './documents.repository'

export class DocumentsService extends BaseService<Document> {
    constructor(private rep: DocumentsRepository) {
        super(rep)
    }
}
